import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import {
  selectIsAuthenticated,
  selectIsAuthenticating,
} from "../../app/store/selectors";
import { combineLatest, Observable } from "rxjs";
import { ROUTES_CONFIG } from "../config";
import { CookieService } from "../services/cookie.service";
@Injectable({ providedIn: "root" })
export default class PaymentResultGuard implements CanActivate {
  /**
   *
   * @param router
   * @param _store
   */
  constructor(
    private router: Router,
    private _store: Store<IAppState>,
    private cookieService: CookieService,
    private activatedRoute: ActivatedRoute,
  ) {
    //
  }

  /**
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      let paymentResultParam = route.params.result;

      this.cookieService.checkCookie("payment-result") &&
      (paymentResultParam === "success" || paymentResultParam === "failed")
        ? observer.next(true)
        : this.router.navigate([""]),
        observer.next(false);
    });
  }
}
